import * as React from 'react';
import InputContainer from 'src/modules/commons/inputs/input/Input.container';
import { Moment } from 'moment';
import * as moment from 'moment';

interface Props {
  label: string;
  required?: boolean;
  value?: Moment;
  handleChange(value: Moment): void;
}

class Datepicker extends React.PureComponent<Props> {

  constructor(props: Props) {
    super(props);

    this.setDay = this.setDay.bind(this);
    this.setMonth = this.setMonth.bind(this);
    this.setYear = this.setYear.bind(this);
  }

  public render(): React.ReactNode {
    return (
      <div>
        <label className="f-w-100">
          {this.props.label} {this.props.required ? '*' : ''}
        </label>
        <div className="row">
          <div className="col-sm-3">
            <div className="dropdown">
              <div
                className="md-input separator-date"
                data-toggle="dropdown"
                role="button"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <InputContainer
                  label=" "
                  placeholder="Día"
                  type="number"
                  required={false}
                  value={
                    this.props.value ?
                      this.props.value.date().toString() :
                      ''
                  }
                  onChange={this.setDay}
                />
              </div>
            </div>
          </div>
          <div className="col-sm-3">
            <div className="dropdown">
              <div
                className="md-input separator-date"
                data-toggle="dropdown"
                role="button"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <InputContainer
                  label=" "
                  placeholder="Mes"
                  type="number"
                  required={false}
                  value={
                    this.props.value ?
                      (this.props.value.month() + 1).toString() :
                      ''
                  }
                  onChange={this.setMonth}
                />
              </div>
            </div>
          </div>
          <div className="col-sm-4">
            <div className="dropdown">
              <div
                className="md-input"
                data-toggle="dropdown"
                role="button"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <InputContainer
                  label=" "
                  placeholder="Año"
                  type="number"
                  required={false}
                  value={
                    this.props.value ?
                      this.props.value.year().toString() :
                      ''
                  }
                  onChange={this.setYear}
                />
              </div>
            </div>
          </div>
          <div className="col-sm-2">
            <span className="calendar pointer" />
          </div>
        </div>
      </div>
    );
  }

  private setDay(value: string): void {
    this.props.handleChange((this.props.value ? this.props.value : moment()).date(parseInt(value, 10)));
  }

  private setMonth(value: string): void {
    value = (parseInt(value, 10) - 1).toString();
    this.props.handleChange((this.props.value ? this.props.value : moment()).month(value));
  }

  private setYear(value: string): void {
    value = value.substring(0, 4);
    this.props.handleChange((this.props.value ? this.props.value : moment()).year(parseInt(value, 10)));
  }
}

export default Datepicker;



// WEBPACK FOOTER //
// ./src/modules/commons/datepicker/Datepicker.component.tsx